import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/BusCompanies/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/BusCompanies/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/BusCompanies/GetById`, payload),
    Add: (payload) => Repository.post(`/api/BusCompanies/Add`, payload),
    Edit: (payload) => Repository.post(`/api/BusCompanies/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/BusCompanies/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/BusCompanies/ChangeStatus`, payload),
}